<template>
  <div>
    <KTCodePreview v-bind:title="'Danh sách nhóm voucher'">
      <template v-slot:toolbar>
        <div class="row">
          <div class="ml-3" v-if="checkPermission('COUPON_INSERT')">
            <b-button
              v-bind:style="btnCreate"
              size="sm"
              variant="primary"
              @click="openForm(null)"
            >
              <i style="font-size: 1rem" class="flaticon2-add-1"></i>Thêm mới
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <div class="col-md-12 mb-5">
          <b-form>
            <b-row class="mb-5">
              <b-col class="pl-0" cols="3">
                <b-input
                  placeholder="Tên nhóm"
                  v-model="apiFilterParam.searchName"
                  class="btn-sm"
                  v-on:keyup.enter="onFilter()"
                ></b-input>
              </b-col>
              <b-col cols="3">
                <b-form-select
                  class="select-style"
                  size="sm"
                  v-model="apiFilterParam.isActive"
                  :options="listStatus"
                  value-field="id"
                  text-field="name"
                >
                </b-form-select>
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col md="1" style="padding-left: 0">
                <b-button
                  style="fontweight: 600; width: 70px"
                  variant="primary"
                  size="sm"
                  @click="onFilter()"
                  >Lọc</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </div>

        <b-table
          :items="listData"
          :fields="fields"
          bordered
          hover
          show-empty
          :busy="onLoading"
          empty-text="Chưa có nhóm voucher nào. Tạo nhóm đầu tiên để bắt đầu sắp xếp các chương trình khuyến mãi."
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="8"></vcl-table>
          </template>
          <template v-slot:cell(index)="row">
            {{ stt(row.index) }}
          </template>
          <template v-slot:cell(name)="row">
            <a
              class="font-weight-bold cursor-pointer"
              @click="goDetail(row.item)"
              >{{ row.item.name }}</a
            >
          </template>
          <template v-slot:cell(description)="row">
            <p class="description-width mb-0" :title="row.item.description">
              {{ row.item.description || '—' }}
            </p>
          </template>
          <template v-slot:cell(totalVoucher)="row">
            <span
              :class="[
                'label label-lg font-weight-bold label-inline',
                row.item.totalVoucher > 0 ? 'label-light-primary' : 'label-light',
              ]"
              >{{ row.item.totalVoucher }}</span
            >
          </template>
          <template v-slot:cell(status)="row">
            <span
              v-text="row.item.status ? 'Mở' : 'Khóa'"
              :class="[
                'label font-weight-bold label-lg label-inline',
                row.item.status ? 'label-light-success' : 'label-light-danger',
              ]"
              style="width: max-content"
            ></span>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <b-dropdown-item @click="goDetail(row.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon-eye"></i>
                    &nbsp; Chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="checkPermission('COUPON_UPDATE')"
                  @click="openForm(row.item)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-pen"></i>
                    &nbsp; Chỉnh sửa
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="checkPermission('COUPON_UPDATE')"
                  @click="onChangeStatus(row.item)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon-lock"></i>
                    &nbsp; {{ row.item.status ? 'Khóa' : 'Mở lại' }}
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="checkPermission('COUPON_DELETE')"
                  @click="confirmDelete(row.item)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i>
                    &nbsp; Xóa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>

        <b-row>
          <b-col>
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số: {{ totalItems }}
            </p>
          </b-col>
          <b-col>
            <b-pagination-nav
              class="custom-pagination"
              v-show="totalPages >= 2"
              :link-gen="linkGen"
              :number-of-pages="totalPages"
              use-router
              @change="fetchData()"
              align="right"
              first-class="page-item-first btn btn-icon btn-sm mr-1 my-1"
              prev-class="page-item-prev btn btn-icon btn-sm mr-.5 my-1"
              next-class="page-item-next btn btn-icon btn-sm mr-1 my-1 ml-.5"
              last-class="page-item-last btn btn-icon btn-sm my-1 "
              page-class="btn btn-icon btn-sm border-0 mr-.5 my-1"
            >
              <template v-slot:first-text>
                <span><i class="ki ki-bold-double-arrow-back icon-xs"></i></span>
              </template>
              <template v-slot:prev-text>
                <i class="ki ki-bold-arrow-back icon-xs"></i>
              </template>
              <template v-slot:next-text>
                <i class="ki ki-bold-arrow-next icon-xs"></i>
              </template>
              <template v-slot:last-text>
                <span class="text-info">
                  <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                </span>
              </template>
            </b-pagination-nav>
          </b-col>
        </b-row>

        <VoucherGroupFormModal ref="formModal" @saved="fetchData" />

        <!-- E-004: nhóm còn chương trình thì không xóa được, gợi ý sang chuyển nhóm -->
        <b-modal ref="blockedModal" title="Không thể xóa nhóm" hide-footer>
          <b-alert show variant="light-danger" class="py-2">
            Nhóm voucher đang chứa {{ blockedGroup.total }} chương trình, vui
            lòng chuyển sang nhóm khác trước khi xóa!
          </b-alert>
          <p>
            Số lượng này tính <b>mọi chương trình chưa bị xóa</b>, kể cả đã hết
            hạn hoặc đang khóa.
          </p>
          <div class="mt-3">
            <b-button
              size="sm"
              variant="primary"
              class="mr-2"
              @click="goDetail(blockedGroup)"
              >Chuyển nhóm cho các chương trình này</b-button
            >
            <b-button
              size="sm"
              variant="secondary"
              @click="$refs.blockedModal.hide()"
              >Đóng</b-button
            >
          </div>
        </b-modal>

        <ConfirmWarningModal
          ref="lockModal"
          title="Khóa nhóm voucher?"
          :notes="lockNotes"
          question="Bạn có chắc muốn khóa nhóm này?"
          confirm-text="Khóa nhóm"
          @confirm="confirmLock()"
        >
          Các chương trình trong nhóm <b>vẫn hoạt động</b> bình thường.
          <template v-slot:note="{ index }">
            <template v-if="index === 0">
              Trên màn bán hàng, các chương trình sẽ hiển thị trong
              <b>“Chưa phân nhóm”</b>.
            </template>
            <template v-else>
              Nhóm đã khóa sẽ <b>không thể nhận thêm chương trình mới</b>.
            </template>
          </template>
        </ConfirmWarningModal>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import localData from '@/utils/saveDataToLocal';
import { VclTable } from 'vue-content-loading';
import VoucherGroupFormModal from '@/view/components/voucher-group/VoucherGroupFormModal.vue';
import ConfirmWarningModal from '@/view/components/ConfirmWarningModal.vue';
import { ACTIVE_STATUS_LIST } from '@/utils/constants';
import { makeToastFaile, makeToastSuccess, getApiErrorMessage } from '@/utils/common';
import { showDeleteAlert } from '@/utils/sweet-alert2';

const PAGE_SIZE = 10;

export default {
  components: {
    KTCodePreview,
    VclTable,
    VoucherGroupFormModal,
    ConfirmWarningModal,
  },
  data() {
    return {
      listData: [],
      onLoading: false,
      btnCreate: { fontWeight: '600!important' },
      totalPages: 1,
      totalItems: 0,
      page: 1,
      linkGen: (pageNum) => (pageNum === 1 ? '?' : `?page=${pageNum}`),
      blockedGroup: { id: null, total: 0 },
      lockingGroup: null,
      // Nội dung từng dòng render qua slot `note` (cần in đậm); mảng chỉ quyết định số dòng
      lockNotes: ['Hiển thị ở “Chưa phân nhóm”', 'Không nhận thêm chương trình mới'],
      // thClass/tdClass thay vì bọc <p class="text-center"> trong ô: bọc trong ô chỉ căn
      // phần thân, tiêu đề vẫn căn trái nên cột số bị lệch so với đầu cột.
      fields: [
        {
          key: 'index',
          label: '#',
          thStyle: { fontWeight: 600, color: '#181c32', width: '4%' },
          thClass: 'text-center',
          tdClass: 'text-center align-middle',
        },
        {
          key: 'name',
          label: 'Tên nhóm',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          tdClass: 'align-middle',
        },
        {
          key: 'description',
          label: 'Mô tả',
          thStyle: { fontWeight: 600, color: '#181c32', width: '31%' },
          tdClass: 'align-middle',
        },
        {
          key: 'totalVoucher',
          label: 'Số CT',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          thClass: 'text-center',
          tdClass: 'text-center align-middle',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          thClass: 'text-center',
          tdClass: 'text-center align-middle',
        },
        {
          key: 'createdByName',
          label: 'Người tạo',
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'align-middle',
        },
        {
          key: 'createdAt',
          label: 'Ngày tạo',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          thClass: 'text-center',
          tdClass: 'text-center align-middle',
        },
        {
          key: 'actions',
          label: '',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'align-middle',
        },
      ],
      apiFilterParam: {
        searchName: '',
        isActive: null,
      },
      listStatus: ACTIVE_STATUS_LIST,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Khuyến mãi' },
      { title: 'Voucher sản phẩm' },
      { title: 'Nhóm voucher' },
    ]);
  },
  methods: {
    checkPermission(condition) {
      return localData.checkPermission(condition);
    },
    stt(index) {
      return (this.page - 1) * PAGE_SIZE + index + 1;
    },
    fetchData() {
      this.onLoading = true;
      this.page = Number(this.$route.query.page) || 1;
      const params = {
        page: this.page,
        limit: PAGE_SIZE,
        searchName: this.apiFilterParam.searchName,
        isActive: this.apiFilterParam.isActive,
      };
      ApiService.query('v2/voucher-groups', { params })
        .then(({ data }) => {
          this.totalPages = data.data.totalPage;
          this.totalItems = data.data.totalRow;
          this.listData = data.data.dataset;
          this.onLoading = false;
        })
        .catch(() => {
          this.onLoading = false;
        });
    },
    onFilter() {
      this.$router.push({ name: 'list-voucher-group' }).catch(() => {});
      this.fetchData();
    },
    openForm(group) {
      this.$refs.formModal.show(group);
    },
    goDetail(item) {
      this.$router.push({
        name: 'detail-voucher-group',
        query: { id: item.id },
      });
    },
    onChangeStatus(item) {
      // Chỉ cảnh báo khi khóa: dễ hiểu nhầm là khóa nhóm sẽ ngừng luôn voucher bên trong
      if (item.status) {
        this.lockingGroup = item;
        this.$refs.lockModal.show();
        return;
      }
      this.updateStatus(item);
    },
    confirmLock() {
      this.updateStatus(this.lockingGroup);
    },
    updateStatus(item) {
      ApiService.put('v2/voucher-groups/status', {
        voucherGroupId: item.id,
        // `status` là cờ hiện tại nên phải đảo, không gửi thẳng
        isActive: !item.status,
        // Dấu phiên bản đọc lúc tải danh sách — nhóm vừa bị người khác khóa/mở thì
        // BE từ chối ghi đè và báo tải lại (BR-013)
        updatedAt: item.updatedAt,
      })
        .then(({ data }) => {
          makeToastSuccess(data.message);
          this.fetchData();
        })
        .catch((err) => {
          makeToastFaile(getApiErrorMessage(err));
          this.fetchData();
        });
    },
    confirmDelete(item) {
      // Nhóm còn chương trình thì chặn ngay, kèm lối đi sang chuyển nhóm hàng loạt.
      // Số hiển thị lấy từ danh sách, còn chốt chặn thật nằm ở BE (đếm lúc bấm xóa).
      if (item.totalVoucher > 0) {
        this.blockedGroup = { id: item.id, total: item.totalVoucher };
        this.$refs.blockedModal.show();
        return;
      }
      showDeleteAlert(
        'Xóa nhóm voucher',
        `Xóa nhóm "${item.name}"? Nhóm này không còn chương trình nào. Thao tác không hoàn tác được.`,
        item,
        this.deleteItem,
      );
    },
    deleteItem(item) {
      ApiService.delete(`v2/voucher-groups/${item.id}`)
        .then(({ data }) => {
          makeToastSuccess(data.message);
          this.fetchData();
        })
        .catch((err) => {
          makeToastFaile(getApiErrorMessage(err));
          this.fetchData();
        });
    },
  },
};
</script>

<style scoped>
.description-width {
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
